import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth";
import Post from "../../helpers/ajax/post";
import Get from "../../helpers/ajax/get";

const SubmitterLogin = () => {
    document.title = "Work Tickets Login | Dependable";
    const { loadSubmitterData } = useContext(AuthContext);
    const navigate = useNavigate();

    const [names, setNames] = useState([]);
    const [selectedName, setSelectedName] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [loginError, setLoginError] = useState(null);
    const [mode, setMode] = useState("login"); // 'login', 'setup', 'forgot'
    const [forgotMessage, setForgotMessage] = useState("");
    const [LogginIn, setLogginIn] = useState(false);

    useEffect(() => {
        Get("/api/submitters/names")
            .then((data) => setNames(data.names || []))
            .catch(console.log);
    }, []);

    const handleLogin = async (ev) => {
        ev.preventDefault();
        if (!password || !selectedName) {
            return false;
        }
        setLogginIn(true);
        setLoginError(null);
        try {
            await Post("/login", {
                password: password,
                username: selectedName,
            });
            await loadSubmitterData();
            navigate("/submitter/jobs");
        } catch (error) {
            if (error.requireSetup) {
                setMode("setup");
                setLoginError(null);
            } else {
                setLoginError(error.error);
            }
        } finally {
            setLogginIn(false);
        }
    };

    const handleSetup = async (ev) => {
        ev.preventDefault();
        if (!password || !password2) {
            return false;
        }
        setLogginIn(true);
        setLoginError(null);
        try {
            await Post("/api/submitters/setup", {
                name: selectedName,
                password: password,
                password2: password2,
            });
            await loadSubmitterData();
            navigate("/submitter/jobs");
        } catch (error) {
            setLoginError(error.error);
        } finally {
            setLogginIn(false);
        }
    };

    const handleForgot = async (ev) => {
        ev.preventDefault();
        if (!selectedName) {
            return false;
        }
        setLogginIn(true);
        setLoginError(null);
        setForgotMessage("");
        try {
            await Post("/api/submitters/forgot", { name: selectedName });
            setForgotMessage("A password reset link has been sent to the email on file for this submitter.");
        } catch (error) {
            setLoginError(error.error);
        } finally {
            setLogginIn(false);
        }
    };

    return (
        <div style={{ backgroundImage: "url('/images/main_bg.jpg')" }} className="bg-center bg-no-repeat bg-cover">
            <div className="flex justify-center min-h-screen bg-white/90">
                <form onSubmit={mode === "login" ? handleLogin : mode === "setup" ? handleSetup : handleForgot} className="bg-white w-96 shadow-2xl self-center inline-block rounded-lg p-8">
                    <img alt="logo" src="/images/dependable-logo-reg.jpg" className="inline-block mx-auto w-1/2" />
                    <h2 className="mt-4 mb-3">
                        {mode === "login" && "Work Tickets Login"}
                        {mode === "setup" && `Set Up Password - ${selectedName}`}
                        {mode === "forgot" && "Forgot Password"}
                    </h2>

                    {mode === "login" && (
                        <>
                            <select
                                required
                                className="w-full block mb-5 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30 p-3"
                                value={selectedName}
                                onChange={(e) => setSelectedName(e.target.value)}
                            >
                                <option value="">Select who you are</option>
                                {names.map((name) => (
                                    <option key={name} value={name}>{name}</option>
                                ))}
                            </select>
                            <input
                                required
                                className="w-full block mb-5 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30 p-3"
                                placeholder="Password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                disabled={LogginIn}
                                className="bg-dependable disabled:opacity-50 block text-white w-full p-3 font-bold rounded-md focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30"
                                type="submit"
                            >
                                Login
                                {LogginIn && (
                                    <div className="ml-4 spinner-border animate-spin inline-block w-4 h-4 border-4 text-white rounded-full"></div>
                                )}
                            </button>
                            {selectedName && (
                                <p className="text-right mt-3 text-dependable">
                                    <button type="button" className="underline" onClick={() => { setMode("forgot"); setLoginError(null); }}>
                                        Forgot password?
                                    </button>
                                </p>
                            )}
                        </>
                    )}

                    {mode === "setup" && (
                        <>
                            <p className="text-sm text-gray-600 mb-4">No password is set up for this submitter yet. Please create one.</p>
                            <input
                                required
                                className="w-full block mb-5 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30 p-3"
                                placeholder="New Password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <input
                                required
                                className="w-full block mb-3 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30 p-3"
                                placeholder="Confirm Password"
                                type="password"
                                value={password2}
                                onChange={(e) => setPassword2(e.target.value)}
                            />
                            <p className="text-sm text-left mb-3">Password must contain at least 8 characters, have an uppercase, lowercase and digit</p>
                            <button
                                disabled={LogginIn}
                                className="bg-dependable disabled:opacity-50 block text-white w-full p-3 font-bold rounded-md focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30"
                                type="submit"
                            >
                                Set Up Password
                                {LogginIn && (
                                    <div className="ml-4 spinner-border animate-spin inline-block w-4 h-4 border-4 text-white rounded-full"></div>
                                )}
                            </button>
                            <p className="text-right mt-3 text-dependable">
                                <button type="button" className="underline" onClick={() => { setMode("login"); setPassword(""); setPassword2(""); setLoginError(null); }}>
                                    Back to login
                                </button>
                            </p>
                        </>
                    )}

                    {mode === "forgot" && (
                        <>
                            <p className="text-sm text-gray-600 mb-4">A password reset link will be sent to the email on file for <strong>{selectedName}</strong>.</p>
                            <button
                                disabled={LogginIn}
                                className="bg-dependable disabled:opacity-50 block text-white w-full p-3 font-bold rounded-md focus:outline-none focus:ring-2 ring-offset-2 ring-dependable/30"
                                type="submit"
                            >
                                Send Reset Link
                                {LogginIn && (
                                    <div className="ml-4 spinner-border animate-spin inline-block w-4 h-4 border-4 text-white rounded-full"></div>
                                )}
                            </button>
                            <p className="text-right mt-3 text-dependable">
                                <button type="button" className="underline" onClick={() => { setMode("login"); setLoginError(null); setForgotMessage(""); }}>
                                    Back to login
                                </button>
                            </p>
                            {forgotMessage && <p className="text-green-700 text-left mt-4">{forgotMessage}</p>}
                        </>
                    )}

                    {!!loginError && <p className="text-red-800 text-left mt-4">{loginError}</p>}
                </form>
            </div>
        </div>
    );
};

export default SubmitterLogin;